<template>
  <div>
    <el-card>
      <div slot="header">
        <span style="font-weight:600;font-size:16px;">{{ isEdit ? '编辑文章' : '新增文章' }}</span>
        <el-button style="float:right;" type="text" icon="el-icon-back" @click="$router.push('/admin')">返回列表</el-button>
      </div>

      <el-form :model="form" :rules="rules" ref="articleForm" :label-width="isMobile ? '60px' : '80px'" :label-position="isMobile ? 'top' : 'right'">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" placeholder="请输入文章标题"></el-input>
        </el-form-item>
        <el-form-item label="分类" prop="category">
          <el-select v-model="form.category" placeholder="选择分类" allow-create filterable>
            <el-option v-for="c in categories" :key="c" :label="c" :value="c"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="摘要" prop="summary">
          <el-input v-model="form.summary" type="textarea" :rows="3" placeholder="文章摘要"></el-input>
        </el-form-item>
        <el-form-item label="作者">
          <el-input v-model="form.author" placeholder="作者"></el-input>
        </el-form-item>
        <el-form-item label="正文" prop="content">
          <el-input v-model="form.content" type="textarea" :rows="15" placeholder="支持Markdown格式"></el-input>
        </el-form-item>
        <el-form-item label="发布">
          <el-switch v-model="form.published" active-text="发布" inactive-text="草稿"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="saving" @click="handleSave">
            {{ isEdit ? '更新文章' : '创建文章' }}
          </el-button>
          <el-button @click="$router.push('/admin')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from '../api'

export default {
  name: 'AdminEdit',
  data() {
    return {
      form: {
        title: '',
        summary: '',
        content: '',
        category: '',
        author: '胡工',
        published: true,
        viewCount: 0
      },
      categories: ['大模型', 'AI应用', '国产AI', 'AI Agent', 'RAG技术', '深度学习', '行业动态'],
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        category: [{ required: true, message: '请选择分类', trigger: 'change' }],
        summary: [{ required: true, message: '请输入摘要', trigger: 'blur' }],
        content: [{ required: true, message: '请输入正文', trigger: 'blur' }]
      },
      saving: false,
      isMobile: false
    }
  },
  computed: {
    isEdit() {
      return !!this.$route.params.id
    }
  },
  created() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
    if (this.isEdit) this.loadArticle()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() { this.isMobile = window.innerWidth <= 768 },
    async loadArticle() {
      const { data } = await api.getArticle(this.$route.params.id)
      this.form = { ...data }
    },
    handleSave() {
      this.$refs.articleForm.validate(async (valid) => {
        if (!valid) return
        this.saving = true
        try {
          if (this.isEdit) {
            await api.updateArticle(this.$route.params.id, this.form)
            this.$message.success('更新成功')
          } else {
            await api.createArticle(this.form)
            this.$message.success('创建成功')
          }
          this.$router.push('/admin')
        } catch {
          this.$message.error('操作失败')
        } finally {
          this.saving = false
        }
      })
    }
  }
}
</script>
